import { FlexLayout } from '@deity/falcon-ui';
import { NavigateToEntity } from 'components';
import { EDITOR_PATH_ID, ENTITY_PATH_ID } from 'contracts/constants';
import { ContentContainer } from 'layouts';
import type { FC } from 'react';
import { useLocation } from 'react-router-dom';
import { getParams } from 'utils';
import FlowEditorFooter from './FlowEditorFooter';
import styles from './Footer.module.css';
import MappingEditorFooter from './MappingEditorFooter';
import { NavigateBack } from './NavigateBack';

export const Footer: FC = () => {
  const { pathname } = useLocation();
  const params: any = getParams(pathname, [EDITOR_PATH_ID, ENTITY_PATH_ID]);

  return (
    <FlexLayout
      alignItems="center"
      justifyContent="center"
      boxShadow="subtle"
      bg="white"
      as="footer"
      width="full"
      className={styles.wrapper}
      style={{ transform: `translateY(${params.entity ? 0 : '100px'})` }}
    >
      <ContentContainer>
        {params.entity === 'structures' && <NavigateToEntity linkText="Structures" />}
        {params.entity === 'endpoints' && <NavigateBack linkText="Endpoints" />}
        {params.entity === 'services' && <NavigateToEntity linkText="Services" />}
        {params.entity === 'flows' && !params.editor && <NavigateToEntity linkText="Flows" />}
        {params.entity === 'mappings' && !params.editor && <NavigateToEntity linkText="Mappings" />}
        {params.entity === 'flows' && params.editor === 'editor' && <FlowEditorFooter params={params} />}
        {params.entity === 'mappings' && params.editor === 'editor' && <MappingEditorFooter params={params} />}
      </ContentContainer>
    </FlexLayout>
  );
};
